import { createContext } from "react";

export const IsFullRenderdContext = createContext<boolean>(false);
export const SetIsFullRenderdContext = createContext<
  React.Dispatch<React.SetStateAction<boolean>>
>(() => {});
